import { render, staticRenderFns } from "./pageConfigModal.vue?vue&type=template&id=895070d2&scoped=true"
import script from "./pageConfigModal.vue?vue&type=script&lang=js"
export * from "./pageConfigModal.vue?vue&type=script&lang=js"
import style0 from "./pageConfigModal.vue?vue&type=style&index=0&id=895070d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895070d2",
  null
  
)

export default component.exports